import { render, staticRenderFns } from "./CopyLinkHover.vue?vue&type=template&id=13cc5d38"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13cc5d38')) {
      api.createRecord('13cc5d38', component.options)
    } else {
      api.reload('13cc5d38', component.options)
    }
    module.hot.accept("./CopyLinkHover.vue?vue&type=template&id=13cc5d38", function () {
      api.rerender('13cc5d38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/CopyLinkHover.vue"
export default component.exports